module.exports = __webpack_public_path__ + "img/bqjy.9eaa0746.jpg";